import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { trackByValue } from '@y42/angular/util';
import { GoJsLegend, GoJSLegendPosition } from './gojs-legend.model';

@Component({
  selector: 'y42-gojs-legend[legendItems]',
  templateUrl: './gojs-legend.component.html',
  styleUrls: ['./gojs-legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GojsLegendComponent {
  @Input() legendItems: GoJsLegend[] = [];
  @Input() expandLegend = true;
  @Input() position: GoJSLegendPosition = 'right-with-sidebar';

  readonly trackByValue = trackByValue;
  protected isPanelOpened = false;
}
